/*eslint-disable*/
import Vue from 'vue';
import App from './App';

import Storage from 'vue-ls';
import BootstrapVue from 'bootstrap-vue';
import FontAwesome from '@/components/icons/FontAwesome';
import Loader from '@/components/core/Loader';

import store from './store/';
import router from './router/';
import Snotify from 'vue-snotify'; 

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'vue-snotify/styles/material.css'; 

Vue.use(Storage, {name: 'ls', storage: 'local'});
Vue.use(BootstrapVue);
Vue.use(Snotify);

Vue.component('FontAwesome', FontAwesome);
Vue.component('Loader', Loader);

Vue.config.productionTip = false;

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app');
